import { type Opportunity } from "@repo/api";

import { STAGE_ACTIONS_SECTION_IDS, StagesActionEnum } from "./config";

interface HandleStageActionClickParams {
  action: StagesActionEnum;
  pushModal: (modal: any) => void;
  opportunity: Opportunity | null | undefined;
}

const highlightElement = (elementId: string) => {
  setTimeout(() => {
    const element = document.getElementById(elementId);
    if (!element) {
      return;
    }

    element.classList.add("highlight-box");

    setTimeout(() => {
      element.classList.remove("highlight-box");
    }, 2000);
  }, 500);
};

const scrollToElement = (
  scrollToElementId: string,
  options?: ScrollIntoViewOptions
) => {
  const element = document.getElementById(scrollToElementId);
  element?.scrollIntoView({ behavior: "smooth", block: "center", ...options });
};

export const handleStageActionClick = ({
  action,
  pushModal,
  opportunity,
}: HandleStageActionClickParams) => {
  switch (action) {
    case StagesActionEnum.OPEN_DETAILS_MODAL:
      pushModal({ type: "PROJECT_DETAILS" });
      break;
    case StagesActionEnum.OPEN_BOOKING_MODAL:
      pushModal({ type: "BOOK_APPOINTMENT" });
      break;
    case StagesActionEnum.OPEN_TASK_MODAL:
      pushModal({
        type: "TASK",
        initialData: {
          selectedCoworkers: opportunity?.owner
            ? [opportunity.owner]
            : undefined,
        },
        opportunityId: opportunity?.id,
        context: "PROJECT",
      });
      break;
    case StagesActionEnum.SCROLL_TO_UPCOMING_SECTION: {
      scrollToElement(STAGE_ACTIONS_SECTION_IDS.UPCOMING_SECTION);
      highlightElement(STAGE_ACTIONS_SECTION_IDS.UPCOMING_SECTION);
      break;
    }
    case StagesActionEnum.OPEN_ANALYSIS_MODAL:
      pushModal({ type: "NEED_ANALYSIS" });
      break;
    case StagesActionEnum.SCROLL_TO_DRAWINGS_SECTION: {
      scrollToElement(STAGE_ACTIONS_SECTION_IDS.DRAWINGS_SECTION);
      highlightElement(STAGE_ACTIONS_SECTION_IDS.DRAWINGS_SECTION);
      break;
    }
    case StagesActionEnum.SCROLL_TO_LEFT_SECTION: {
      scrollToElement(STAGE_ACTIONS_SECTION_IDS.LEFT_SECTION);
      break;
    }
    case StagesActionEnum.SCROLL_TO_RECORD_ACTIVITY_SECTION: {
      scrollToElement(STAGE_ACTIONS_SECTION_IDS.RECORD_ACTIVITY_SECTION);
      break;
    }
    case StagesActionEnum.SCROLL_TO_HISTORY_SECTION: {
      scrollToElement(STAGE_ACTIONS_SECTION_IDS.HISTORY_SECTION);
      highlightElement(STAGE_ACTIONS_SECTION_IDS.HISTORY_SECTION);
      break;
    }
    case StagesActionEnum.SCROLL_TO_NOTES_SECTION: {
      scrollToElement(STAGE_ACTIONS_SECTION_IDS.NOTES_SECTION);
      highlightElement(STAGE_ACTIONS_SECTION_IDS.NOTES_SECTION);
      break;
    }
    case StagesActionEnum.OPEN_CONSENT_MODAL: {
      pushModal({ type: "CONSENT_SETTINGS" });
      break;
    }
    case StagesActionEnum.SCROLL_TO_ORDERS_SECTION: {
      scrollToElement(STAGE_ACTIONS_SECTION_IDS.ORDERS_SECTION);
      highlightElement(STAGE_ACTIONS_SECTION_IDS.ORDERS_SECTION);
      break;
    }
    case StagesActionEnum.SCROLL_TO_FILES_SECTION: {
      scrollToElement(STAGE_ACTIONS_SECTION_IDS.FILES_SECTION);
      highlightElement(STAGE_ACTIONS_SECTION_IDS.FILES_SECTION);
      break;
    }

    case StagesActionEnum.NO_ACTION:
    default:
      return null;
  }
};
